export default __webpack_public_path__ + "static/media/f5b942dbb78fe0b82afdee2eac9b56e1.svg";